export default function PrestationsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('prestations');
}

PrestationsConfiguration.$inject = ['$translatePartialLoaderProvider'];
